import { useRef, useEffect } from 'react';

// Custom hook to track if a component is mounted
export const useIsMounted = () => {
  const isMountedRef = useRef(true);
  
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  
  return () => isMountedRef.current;
};

export default useIsMounted;